var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "56px",
    viewBox: "0 0 48 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA798A81-5B2F-4E6A-BA97-50E9A8175713") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "22.767153 0 0.723684211 0 0.723684211 36 28.7236842 36 28.7236842 5.99924799"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-38.9%",
    width: "214.3%",
    height: "188.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1015625 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CMHC_UI-Kit_Iconography",
    transform: "translate(-1120.000000, -3749.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-microsoft-office-/-excel",
    transform: "translate(1124.000000, 3755.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "csv-(2)",
    transform: "translate(5.276316, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E4E4E4",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#007934",
    points: "23.7236842 3 0.723684211 3 0.723684211 0 22.8004868 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.723684, 26.000000)",
    fill: "#A4A9AD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62465574,1.34497959 C2.28245902,1.34497959 2.01519672,1.49473469 1.82344262,1.79387755 C1.63168852,2.09314286 1.5357541,2.50579592 1.5357541,3.03171429 C1.5357541,4.12506122 1.92545902,4.67167347 2.70486885,4.67167347 C2.94034426,4.67167347 3.16859016,4.63677551 3.38960656,4.56685714 C3.6105082,4.49693878 3.83255738,4.41269388 4.05609836,4.3142449 L4.05609836,5.61232653 C3.61177049,5.82208163 3.10914754,5.92702041 2.54822951,5.92702041 C1.7444918,5.92702041 1.12837705,5.67832653 0.699885246,5.18081633 C0.271393443,4.68342857 0.0570327869,3.96440816 0.0570327869,3.02387755 C0.0570327869,2.4357551 0.160770492,1.91902041 0.36847541,1.47330612 C0.576065574,1.02759184 0.874655738,0.684979592 1.26447541,0.445346939 C1.65418033,0.205714286 2.1125082,0.0857142857 2.63922951,0.0857142857 C3.21483607,0.0857142857 3.7647377,0.219183673 4.28916393,0.486122449 L3.84839344,1.69481633 C3.65181967,1.5962449 3.45501639,1.51346939 3.25844262,1.44612245 C3.0617541,1.37877551 2.85060656,1.34497959 2.62465574,1.34497959 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57580328,4.12383673 C8.57580328,4.4762449 8.49214754,4.78910204 8.32437705,5.06240816 C8.15695082,5.33571429 7.91527869,5.54816327 7.59970492,5.6997551 C7.28401639,5.85122449 6.91381967,5.92702041 6.48877049,5.92702041 C6.13429508,5.92702041 5.83685246,5.90044898 5.59655738,5.84742857 C5.35614754,5.79428571 5.10609836,5.70159184 4.84629508,5.56946939 L4.84629508,4.20146939 C5.12067213,4.35171429 5.40595082,4.46914286 5.70213115,4.55314286 C5.99842623,4.6375102 6.27027869,4.6795102 6.51791803,4.6795102 C6.73159016,4.6795102 6.88822951,4.64008163 6.98783607,4.56085714 C7.08732787,4.48187755 7.1372459,4.38012245 7.1372459,4.25583673 C7.1372459,4.17808163 7.11716393,4.11012245 7.07711475,4.05183673 C7.03706557,3.99342857 6.97268852,3.93453061 6.88409836,3.87502041 C6.7955082,3.8155102 6.55934426,3.69379592 6.17572131,3.5097551 C5.82847541,3.34138776 5.56798361,3.17816327 5.39436066,3.02008163 C5.2207377,2.862 5.09209836,2.68077551 5.00832787,2.47604082 C4.92455738,2.27130612 4.88267213,2.02910204 4.88267213,1.74918367 C4.88267213,1.22595918 5.06111475,0.817959184 5.41811475,0.525061224 C5.77488525,0.232285714 6.26545902,0.0858367347 6.8894918,0.0858367347 C7.44065574,0.0858367347 8.00260656,0.221877551 8.57568852,0.493959184 L8.13491803,1.67938776 C7.63722951,1.43583673 7.20747541,1.314 6.84577049,1.314 C6.65872131,1.314 6.52285246,1.34902041 6.43781967,1.41893878 C6.35278689,1.48885714 6.31032787,1.57567347 6.31032787,1.67938776 C6.31032787,1.79081633 6.36437705,1.89061224 6.47236066,1.97853061 C6.58034426,2.06669388 6.87354098,2.22722449 7.35195082,2.4604898 C7.81085246,2.68077551 8.12952459,2.91710204 8.30796721,3.16971429 C8.48663934,3.42232653 8.57580328,3.74044898 8.57580328,4.12383673 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3893115,0.167510204 L13.9989672,0.167510204 L12.2544754,5.84926531 L10.5608197,5.84926531 L8.82355738,0.167510204 L10.4406721,0.167510204 L11.165459,3.04738776 C11.3160164,3.68742857 11.3985246,4.13289796 11.4130984,4.38428571 C11.430082,4.20293878 11.4639344,3.97616327 11.5151148,3.70408163 C11.5659508,3.432 11.6109344,3.21832653 11.6498361,3.06293878 L12.3893115,0.167510204 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D1D3D3",
    points: "22.7236842 6 28.7236842 6 22.7236842 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.723684, 9.000000)",
    fill: "#007934"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.62992174,
    y: 0.0414457831,
    width: 3.7614087,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.22457391,
    y: 0.0414457831,
    width: 3.76129565,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.62992174,
    y: 2.73024096,
    width: 3.7614087,
    height: 1.85771084
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.22457391,
    y: 2.73024096,
    width: 3.76129565,
    height: 1.85771084
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.62992174,
    y: 5.41915663,
    width: 3.7614087,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.22457391,
    y: 5.41915663,
    width: 3.76129565,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.0352695652,
    y: 5.41915663,
    width: 3.76129565,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.62992174,
    y: 8.10819277,
    width: 3.7614087,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.22457391,
    y: 8.10819277,
    width: 3.76129565,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.0352695652,
    y: 8.10819277,
    width: 3.76129565,
    height: 1.85759036
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.74038261 4.35686747 2.60542609 4.35686747 1.89754783 3.14710843 1.19713043 4.35686747 0.0869304348 4.35686747 1.29152174 2.37674699 0.15893913 0.486746988 1.24686957 0.486746988 1.90252174 1.68337349 2.53341739 0.486746988 3.65356522 0.486746988 2.50357391 2.45891566"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/CSV.631c1e99b30decab16f53b583769a35d.svg";
export { ForwardRef as ReactComponent };